export default {
    namespaced: true,
    state: {
    	// 头部banner
        readBanner:'',
        logo:'',
        // logo样式
        logoType:'',
        // 产品排版
        productType:'',
        //皮肤
        skin:'',
        colorType: '',
        productType: '',
        logo: '',
        logoType: '',
        readBanner: '',
        companyName: '',
        limit: ''
    },
    mutations: {
        setSkin (state, payLoad) {
            state.skin = payLoad
        },
        setColorType (state, payLoad) {
            state.colorType = payLoad.colorType
        },
        setProductType (state, payLoad) {
            state.productType = payLoad.productType
        },
        setLogo (state, payLoad) {
            state.logo = payLoad.logo
        },
        setLogoType (state, payLoad) {
            state.logoType = payLoad.logoType
        },
        setReadBanner (state, payLoad) {
            state.readBanner = payLoad.readBanner
        },
        setCompanyName (state, payLoad) {
            state.companyName = payLoad.companyName
        },
        setLimit (state, payLoad) {
            state.limit = payLoad.limit
        }
        
    },
    actions: {
        setColumn (context, payLoad) {
            context.commit('setColorType', payLoad)
            context.commit('setProductType', payLoad)
            context.commit('setLogo', payLoad)
            context.commit('setLogoType', payLoad)
            context.commit('setReadBanner', payLoad)
            context.commit('setCompanyName', payLoad)
            context.commit('setLimit', payLoad)
        }
    },
    getters: {
    	skin: state => state.skin,
    	colorType: state => state.colorType,
    	productType: state => state.productType,
    	logoType: state => state.logoType,
    	logo: state => state.logo,
    	readBanner: state => state.readBanner,
    	companyName: state => state.companyName,
        limit: state => state.limit
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/readme.js